<template>
  <div class="cloud">
    <div class="cloud_tree">
      <el-tree :data="data" :render-content="renderContent" :default-expanded-keys="defaultProps" node-key="id"
               @node-click="handleNodeClick"></el-tree>
    </div>
    <div class="flex">
      <div class="action">
        <div class="btns" style="display: flex;justify-content: space-between">
          <div style="display: flex;align-items: center">
            <el-button style="margin-right:20px" v-if="id !== 0" size="mini"
                       @click="onBack">返回
            </el-button>
            <span :style="index === nameArr.length-1 ? 'color:#b1b1b1' : ''"
                  v-for="(item,index) in nameArr"
                  :key="index"
                  @click="id = item.id">
              {{ item.name }} {{ index === nameArr.length - 1 ? '' : '/' }}
            </span>
            <transition>
              <div v-if="record.id  && this.selectImg" style="margin-left: 20px">
                <el-button type="primary" size='mini' v-show="record && record.type !=='FOLDER'"
                           @click="handleClickImg(record)" style="margin-right:10px">下载
                </el-button>
                <el-button size='mini' v-show="record"  type="primary"
                           @click="handleClickRename(record)" style="margin-right:10px">重命名
                </el-button>
                <el-button size='mini' type="danger" @click="handleDelete">删除</el-button>
              </div>
            </transition>
          </div>
          <div style="display: flex;justify-content: flex-end">
            <div>
              <el-button size='mini' type="primary" @click="handleCreateFolder" style="margin-right: 10px">新建文件夹</el-button>
              <el-upload
                style="display:inline-block;"
                class="upload-demo"
                :action="baseUrl"
                :headers="headers"
                method="post"
                :data='fileData'
                name="uploadFile"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-error="handleError"
                :before-upload='handleBeforeUpload'>
                <el-button size="mini" type="primary">文件上传</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="file_box">
        <div v-for="(item,index) in fileAll" :key="index">
          <div  :key="item.id" :class="{'active': item.id === selectImg}"
               @click.stop="handleClick(item)" :title="`文件名称 : ${item.name}`">
            <img v-if="item.type == 'FOLDER'" src="@/assets/icon/folder.jpg" mode="aspectFit"
                 @click.stop="handleClickImg(item)"/>
            <img class="img" v-else-if="item.suffix == 'jpg' || item.suffix == '.jpg'" src="@/assets/icon/img.png"
                 mode="aspectFit"/>
            <img class="img" v-else-if="item.suffix == 'video' || item.suffix == '.video'" src="@/assets/icon/video.png"
                 mode="aspectFit"/>
            <img class="img" v-else-if="item.suffix == 'doc' || item.suffix == '.doc'" src="@/assets/icon/words.png"
                 mode="aspectFit"/>
            <img class="img" v-else-if="item.suffix == 'xls' || item.suffix == '.xls'" src="@/assets/icon/xlsx.png"
                 mode="aspectFit"/>
            <img class="img" v-else-if="item.suffix == 'pdf' || item.suffix == '.pdf'" src="@/assets/icon/pdf.png"
                 mode="aspectFit"/>
            <img class="img" v-else-if="item.suffix == 'zip' || item.suffix == '.zip'" src="@/assets/icon/zip.png"
                 mode="aspectFit"/>
            <img class="img" v-else-if="item.suffix == 'ppt' || item.suffix == '.ppt'" src="@/assets/icon/ppt.png"
                 mode="aspectFit"/>
            <img v-else src="@/assets/icon/folder.jpg" mode="aspectFit"/>
            <div class="file_name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <CreateFile :visible.sync='visible' :record='record' :id='id' @submitForm='init'/>
    <Rename :visible.sync='visibles' :record='record' @submitForm='init'/>
  </div>
</template>

<script>
import projectConfig from '@/core/config';
import {CloudDisk} from '@/api/knowledge';
import CreateFile from './modules/CreateFile';
import Rename from "./modules/Rename";

export default {
  components: {
    CreateFile,
    Rename
  },
  data() {
    return {
      data: [],
      defaultProps: [0],
      id: 0,
      fileList: [],
      num: 100,
      selectImg: null,
      visible: false,
      record: {},
      baseUrl: projectConfig.baseUrl + 'admin/upms/sysUser/upload',
      headers: null,
      fileData: {
        asImage: false
      },
      token: sessionStorage.getItem('token'),
      nameArr: [{
        name: '共享文件夹',
        id: 0
      }],
      suffix: null,
      renderContent: function (h, {node, data, store}) {
        let addElement = arguments[0];
        return addElement("span", [
          addElement("span", {class: "file_img"}), //可以自定义图标
          addElement("span", "    "),
          addElement("span", arguments[1].node.label),
        ]);
      },
      visibles: false,
      fileAll:[]
    };
  },
  created() {
    this.init()
    this.headers = {
      Authorization: localStorage.getItem('token')
    }
  },
  watch: {
    id() {
      this.nameArr = []
      this.treeFindName(this.id)
      this.getFileAll()
    }
  },
  methods: {
    init() {
      this.data = [{label: "共享文件夹", id: 0, children: []}]
      CloudDisk.getCloudDiskList(this,{}).then(res => {
        this.fileList = res.data.dataList
        const list = JSON.parse(JSON.stringify(res.data.dataList)).filter(item => item.type === 'FOLDER')
        this.listToTree(list, this.data[0].children, 0)
        console.log(this.data);
      })
      this.getFileAll()
    },
    getFileAll(id){
      const data = {
        cloudDiskDtoFilter: {
            pid: this.id
        },
      }
      CloudDisk.getCloudDiskList(this,{...data}).then(res => {
        this.fileAll = res.data.dataList
      })
    },
    handleNodeClick(data) {
      this.id = data.id
      this.defaultProps = [data.id]
      this.selectImg = null
      this.record = {}
      this.getFileAll()

    },
    handleCreateFolder() {
      this.record = {}
      this.visible = true
    },
    handleClick(record) {
      if (this.selectImg === record.id) {
        this.selectImg = null
        this.record = {}
      } else {
        this.selectImg = record.id
        this.record = record
      }
    },
    handleClickImg(record) {
      record.flag = true
      this.record = record
      if (record.downloadPath) {
        this.$confirm('请确认下载该文件!', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '返回',
          type: 'warning'
        }).then(() => {
          const url = record.downloadPath + `&Authorization=${this.token}&dataId=${record.id}`
          this.downloadFile2(url, record.name).then(res => {
            this.$message({
              type: 'success',
              message: '下载成功!'
            });
          }).catch(() => {
            this.$message.error('下载失败');
          })
        }).catch(() => {
        });
      } else {
        this.selectImg = null
        this.id = record.id
        this.defaultProps = [record.pid]
      }
    },
    handleClickText(record) {
      this.selectImg = record.id
      this.record = record
      this.visible = true
    },
    handleSuccess(res) {
      const url = `?fieldName=${this.fileData.fieldName}&asImage=${this.fileData.asImage}&filename=${res.data.filename}` // &Authorization=${this.token}
      const data = {
        downloadPath: projectConfig.baseUrl.slice(0, projectConfig.baseUrl.length - 1) + res.data.downloadUri + url,
        suffix: this.fileData.suffix,
        name: this.fileData.fieldName,
        pid: this.id,
        type: 'FILE'
      }
      CloudDisk.createFile(this, {cloudDiskDto: data}).then(res => {
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        this.getFileAll()
      }).catch(() => {
        this.$message.error('上传失败');
      })
    },
    handleError() {
      this.$message.error('上传失败');
    },
    handleBeforeUpload(file) {
      const arr = file.name.split('.')
      const suffix = this.onChangeType(arr[arr.length - 1])
      this.fileData.suffix = suffix
      this.fileData.asImage = suffix === 'jpg'
      this.fileData.fieldName = file.name
    },
    // 删除
    handleDelete() {
      CloudDisk.deleteFile(this, {id: this.selectImg}).then(res => {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.getFileAll()
      }).catch(() => {
        this.$message.error('删除失败');
      })
    },
    // list 转 tree 递归
    listToTree(list, tree, parentId) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].pid === parentId) {
          const data = {
            label: list[i].name,
            id: list[i].id,
            children: []
          }
          tree.push(data)
          list.splice(i, 1)
          i--
        }
      }
      if (list.length) {
        tree.forEach((item, order) => {
          list.forEach((data, index) => {
            if (item.id === data.pid) {
              this.listToTree(list, tree[order].children, list[index].pid)
            }
          })
        })
      }
    },
    treeFindName(id) {
      let data = {}
      this.fileList.forEach(item => {
        if (item.id * 1 === id * 1) {
          this.nameArr.unshift({
            name: item.name,
            id: item.id
          })
          data = item
        }
      })
      if (data.pid && data.pid !== 0) {
        this.treeFindName(data.pid)
      } else {
        this.nameArr.unshift({
          name: "共享文件夹",
          id: 0
        })
      }
    },
    onChangeType(suffix) {
      switch (suffix) {
        case 'doc':
        case 'docx':
        case 'txt':
          return 'doc'
        case 'mp4':
        case 'mp3':
          return 'video'
        case 'png':
        case 'jpg':
        case 'jpeg':
          return 'jpg'
        case 'pdf':
          return 'pdf'
        case 'xsls':
        case 'xls':
          return 'xls'
        case 'zip':
          return 'zip'
        case '.pptx':
          return 'ppt'
        default:
          return 'file'
      }
    },
    /**
     *@desc 重命名
     *@author Matthew
     *@date 2023/03/24 12:00:39
     */
    handleClickRename(item) {
      this.record = item
      this.visibles = true
    },
    onBack(){
      this.id = this.nameArr[this.nameArr.length-2].id
      this.record = {}
    }
  }
};
</script>
<style lang="scss" scoped>
.cloud {
  width: 98%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  .cloud_tree {
    width: 300px;
  }

  & > div {
    border: 3px solid #ebe9e9;
  }

  .flex {
    flex: 1;
  }

  .action {
    padding: 10px;
  }

  .file_box {
    display: flex;
    flex-wrap: wrap;
    padding-left: 30px;

    & > div > div {
      width: 120px;
      height: 120px;
      padding: 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      border: 1px solid #dddddd;
      border-radius: 8px;
      margin-right: 15px;
      margin-bottom: 15px;
      cursor: pointer;

      img {
        width: 60px;
        -webkit-user-drag: none;
      }

      .img {
        width: 40px;
        padding: 10px 0;
      }

      .file_name {
        width: 100%;
        margin-top: 10px;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    & > div > div:hover {
      border: 1px solid #99b6e2;
      background: #d5e1f1;
    }

    & > div > .active {
      background-color: #ebeff5;
      border-color: rgba(10, 10, 10, 0.34);
    }
  }

  .title {
    background-color: #e8e7e7;
    line-height: 40px;
    border-top: 1px solid #d4d3d3;
    border-bottom: 1px solid #d4d3d3;

    span {
      margin-right: 5px;
      cursor: pointer;
    }
  }

  .btns {
    background-color: #f3f1f1;
    padding: 10px;
    transition: all 1s;

    button {
      padding: 5px 8px;
      font-size: 12px;
      border-radius: 3px;
    }
  }
}

.el-button {
  margin-left: 0 !important;
}
</style>
<style>
.file_img {
  width: 16px;
  height: 20px;
  display: inline-block;
  background: url('../../../assets/icon/folder.gif') 0% 6px / 16px 16px no-repeat;
}

.is-current > .el-tree-node__content {
  background-color: #ccdffc !important;
}
.el-tree-node__content{
  line-height: 30px;
}
</style>
